import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Besttaxiserviceinmumbai() {



    const cardData = {

keyword: "Best Taxi Service in Mumbai",

headingDescription:
    "Mumbai Airport Cab provides the Best Taxi Service in Mumbai, offering safe, reliable, and affordable travel solutions for local city rides, airport transfers, corporate travel, daily commuting, and outstation journeys. We offer a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus with professional, verified, and experienced chauffeurs. With 24x7 availability, instant booking support, doorstep pickup and drop anywhere in Mumbai, transparent pricing, and comfortable rides, we ensure a smooth, secure, and hassle-free travel experience for every passenger across Mumbai and nearby regions.",

topPlaces: [
    {
        title: "Gateway of India",
        description:
            "Gateway of India is one of Mumbai’s most iconic landmarks located in Colaba overlooking the Arabian Sea. Built during the British era, it attracts thousands of visitors daily. Tourists enjoy ferry rides to Elephanta Caves, photography, street shopping, and the lively seaside atmosphere, making it a must-visit destination for anyone traveling in Mumbai."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km long curved promenade along the Arabian Sea. It is one of the most peaceful places in Mumbai for evening walks, relaxation, and sunset views. The sparkling city lights at night create a beautiful necklace-like view, making it a favorite spot for locals and tourists."
    },
    {
        title: "Bandra-Worli Sea Link",
        description:
            "Bandra-Worli Sea Link is a modern engineering marvel that connects South Mumbai to the western suburbs. It offers a smooth driving experience with breathtaking views of the Arabian Sea and Mumbai skyline. The bridge is especially stunning at night when fully illuminated."
    },
    {
        title: "Siddhivinayak Temple",
        description:
            "Siddhivinayak Temple is one of Mumbai’s most famous religious sites dedicated to Lord Ganesha. Devotees from across India visit to seek blessings. The temple is known for its spiritual atmosphere, powerful faith, and well-managed darshan system."
    },
    {
        title: "Haji Ali Dargah",
        description:
            "Haji Ali Dargah is a revered Islamic shrine located on an islet in the Arabian Sea, connected by a narrow causeway. It attracts visitors of all religions and is known for its peaceful ambiance, spiritual significance, and scenic sea views during high tide."
    },
    {
        title: "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        description:
            "CSMT is a UNESCO World Heritage Site and one of Mumbai’s most historic railway stations. Known for its Victorian Gothic architecture and intricate detailing, it represents Mumbai’s colonial heritage and is one of the city’s most important transport hubs."
    },
    {
        title: "Juhu Beach",
        description:
            "Juhu Beach is one of Mumbai’s most popular beaches, known for its lively atmosphere, street food stalls, and sunset views. Visitors enjoy local snacks like pav bhaji, bhel puri, and vada pav while walking along the coastline, making it a favorite family destination."
    },
    {
        title: "Colaba Causeway",
        description:
            "Colaba Causeway is a bustling street shopping destination offering clothes, accessories, souvenirs, and street food. Its vibrant atmosphere and proximity to major landmarks make it a must-visit place for tourists exploring Mumbai."
    },
    {
        title: "Sanjay Gandhi National Park",
        description:
            "Sanjay Gandhi National Park is a large protected green zone within Mumbai offering nature trails, wildlife sightings, and the famous Kanheri Caves. It is a peaceful escape from city life and ideal for trekking, picnics, and nature exploration."
    },
    {
        title: "Elephanta Caves",
        description:
            "Elephanta Caves are ancient rock-cut temples located on Elephanta Island, accessible via ferry from the Gateway of India. The caves feature detailed sculptures dedicated to Lord Shiva and are a UNESCO World Heritage Site, making them one of Mumbai’s top cultural attractions."
    }
],



services: [
{
name: "Best Taxi Service in Mumbai",
description: "Mumbai Airport Cab offers the Best Taxi Service in Mumbai for safe, reliable, and comfortable travel across the city and nearby regions. Whether you need airport transfers, local city rides, corporate travel, family trips, sightseeing, or outstation journeys, we provide a wide fleet of well-maintained AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure punctual pickups, smooth driving experience, and complete safety throughout the journey. With 24x7 availability, transparent pricing, doorstep pickup, and easy online booking, we deliver a premium and hassle-free taxi experience for every traveller."
},
{
name: "Mumbai Best Taxi Service",
description: "Book Mumbai Best Taxi Service with Mumbai Airport Cab for dependable travel solutions across Mumbai. We offer clean vehicles, experienced drivers, affordable pricing, and flexible booking options for all travel needs including local and outstation trips."
},
{
name: "Top Taxi Service Mumbai",
description: "Mumbai Airport Cab provides Top Taxi Service Mumbai with high-quality vehicles, professional chauffeurs, and excellent customer support, ensuring smooth and comfortable rides for business and personal travel."
},
{
name: "Reliable Taxi Service Mumbai",
description: "Choose Reliable Taxi Service Mumbai with guaranteed punctuality, safe driving, verified drivers, and well-maintained cars suitable for daily commuting, airport transfers, and long-distance travel."
},
{
name: "Affordable Taxi Service Mumbai",
description: "Get Affordable Taxi Service Mumbai with budget-friendly fares, transparent pricing, and economical travel options without compromising comfort, safety, or service quality."
},
{
name: "24x7 Taxi Service Mumbai",
description: "Mumbai Airport Cab offers 24x7 Taxi Service Mumbai ensuring round-the-clock availability for airport transfers, emergency travel, late-night rides, and early morning bookings."
},
{
name: "Mumbai Airport Taxi Service",
description: "Mumbai Airport Taxi Service provides direct pickup and drop from both domestic and international terminals with flight tracking, luggage assistance, and timely arrivals for stress-free travel."
},
{
name: "Mumbai Outstation Taxi Service",
description: "Travel comfortably with Mumbai Outstation Taxi Service for long-distance trips to Pune, Goa, Nashik, Shirdi, Lonavala, Indore, and other destinations with experienced chauffeurs and premium vehicles."
},
{
name: "Mumbai Local Taxi Service",
description: "Mumbai Local Taxi Service covers intra-city travel across Andheri, Bandra, Borivali, Dadar, Powai, Kurla, Navi Mumbai, and Thane with reliable and affordable rides."
},
{
name: "Premium Taxi Service Mumbai",
description: "Mumbai Airport Cab offers Premium Taxi Service Mumbai with luxury vehicles, professional chauffeurs, plush interiors, and a high-end travel experience for VIP and executive travel."
},
{
name: "Mumbai Corporate Taxi Service",
description: "Mumbai Corporate Taxi Service is designed for business meetings, employee transport, client visits, and corporate events with punctual service and premium vehicles."
},
{
name: "Mumbai Family Taxi Service",
description: "Book Mumbai Family Taxi Service for safe, comfortable, and spacious travel with child-friendly rides, reliable chauffeurs, and well-maintained vehicles."
},
{
name: "Mumbai Online Taxi Booking",
description: "Mumbai Airport Cab provides Mumbai Online Taxi Booking with instant confirmation, multiple vehicle options, secure payment, and 24x7 customer support."
},
{
name: "Instant Taxi Service Mumbai",
description: "Get Instant Taxi Service Mumbai with quick booking confirmation, fast driver allocation, and immediate pickup for urgent travel requirements."
},
{
name: "Mumbai Ride Taxi Service",
description: "Mumbai Ride Taxi Service offers convenient and flexible travel for daily commuting, short trips, and airport transfers with affordable pricing."
},
{
name: "Safe Taxi Service Mumbai",
description: "Safe Taxi Service Mumbai ensures verified drivers, GPS-enabled vehicles, and strict safety standards for secure travel experience."
},
{
name: "Comfortable Taxi Service Mumbai",
description: "Comfortable Taxi Service Mumbai provides clean AC vehicles, smooth rides, and professional chauffeurs for a relaxing journey experience."
},
{
name: "Mumbai City Taxi Service",
description: "Mumbai City Taxi Service covers all major areas of Mumbai and surrounding regions with reliable, fast, and affordable transportation options."
},
{
name: "Professional Taxi Service Mumbai",
description: "Professional Taxi Service Mumbai ensures trained chauffeurs, punctual service, disciplined driving, and high-quality customer experience."
},
{
name: "Mumbai Cab and Taxi Service",
description: "Mumbai Cab and Taxi Service from Mumbai Airport Cab offers complete transportation solutions including local, airport, and outstation travel with premium comfort and reliability."
}
],

tableData: [
["Best Taxi Service in Mumbai","Mumbai Best Taxi Service"],
["Top Taxi Service Mumbai","Reliable Taxi Service Mumbai"],
["Affordable Taxi Service Mumbai","24x7 Taxi Service Mumbai"],
["Mumbai Airport Taxi Service","Mumbai Outstation Taxi Service"],
["Mumbai Local Taxi Service","Premium Taxi Service Mumbai"],
["Mumbai Corporate Taxi Service","Mumbai Family Taxi Service"],
["Mumbai Online Taxi Booking","Instant Taxi Service Mumbai"],
["Safe Taxi Service Mumbai","Comfortable Taxi Service Mumbai"],
["Mumbai City Taxi Service","Professional Taxi Service Mumbai"],
["Mumbai Ride Taxi Service","Mumbai Cab and Taxi Service"]
],



whychoose: [
{
WhyChooseheading: "Best Taxi Service in Mumbai for Every Journey",
WhyChoosedescription: "Mumbai Airport Cabs provides reliable taxi services in Mumbai for airport transfers, local city rides, corporate travel, sightseeing tours, and outstation journeys."
},
{
WhyChooseheading: "24x7 Taxi Availability Across Mumbai",
WhyChoosedescription: "Our taxi service operates round the clock, allowing customers to book rides anytime for business meetings, family functions, airport transfers, and emergency travel."
},
{
WhyChooseheading: "Local and Outstation Travel Solutions",
WhyChoosedescription: "Whether you need transportation within Mumbai or an outstation trip to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, or other destinations, we provide dependable travel options."
},
{
WhyChooseheading: "Wide Fleet of Comfortable Vehicles",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles based on passenger count and travel requirements."
},
{
WhyChooseheading: "Airport Pickup and Drop Specialists",
WhyChoosedescription: "We specialize in Mumbai Airport transfers with timely pickups, professional drivers, and comfortable vehicles for a hassle-free travel experience."
},
{
WhyChooseheading: "Experienced and Professional Drivers",
WhyChoosedescription: "Our trained chauffeurs ensure safe driving, punctual service, route expertise, and customer-friendly assistance throughout the journey."
},
{
WhyChooseheading: "Corporate and Executive Travel Services",
WhyChoosedescription: "Many companies and business professionals choose Mumbai Airport Cabs for meetings, conferences, client visits, and regular corporate transportation requirements."
},
{
WhyChooseheading: "Comfortable Travel for Families and Groups",
WhyChoosedescription: "From solo travelers to large groups, we provide spacious and comfortable vehicles suitable for vacations, events, and family trips."
}
]
};

const faqData = [
{
question: "Why is Mumbai Airport Cabs considered one of the best taxi services in Mumbai?",
answer: "Mumbai Airport Cabs offers reliable transportation, professional drivers, multiple vehicle options, airport transfers, local rides, and outstation travel services."
},
{
question: "Can I book a taxi for Mumbai Airport transfers?",
answer: "Yes, airport pickup and drop services are available for Terminal 1, Terminal 2, domestic flights, and international travelers."
},
{
question: "Which vehicles are available for booking?",
answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to their travel needs."
},
{
question: "Do you provide outstation taxi services from Mumbai?",
answer: "Yes, outstation taxi services are available for Pune, Nashik, Shirdi, Goa, Ahmedabad, Indore, Bangalore, Jaipur, and many other destinations."
},
{
question: "Can corporate clients use this taxi service regularly?",
answer: "Yes, we provide transportation solutions for executives, employees, business travelers, and corporate organizations."
},
{
question: "Are Tempo Travellers available for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, weddings, corporate outings, and group transportation."
},
{
question: "Can I schedule a taxi in advance?",
answer: "Yes, advance booking is recommended to secure your preferred vehicle and travel schedule."
},
{
question: "Do you provide Mumbai city sightseeing taxi services?",
answer: "Yes, customers can book taxis for Mumbai Darshan, tourist attractions, shopping tours, and customized city sightseeing trips."
},
{
question: "Are your drivers verified and experienced?",
answer: "Yes, all drivers are experienced, professionally trained, and familiar with Mumbai roads, airport procedures, and major travel routes."
},
{
question: "How can I book the best taxi service in Mumbai?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Vikram Shah",
feedback:
"The service quality was outstanding from the moment the taxi arrived. The vehicle was clean, the driver was professional, and the journey was extremely comfortable.",
rating: 5
},
{
id: 2,
name: "Mrs. Anjali Mehta",
feedback:
"Mumbai Airport Cabs consistently delivers excellent service for both airport transfers and outstation trips. Their punctuality and professionalism make them our preferred travel partner.",
rating: 5
}
];











































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Best Taxi Service in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/best-taxi-service-in-mumbai.jpg",
"description": "Book the best taxi service in Mumbai for local travel, airport transfers, outstation trips, corporate rides, and family travel. Mumbai Airport Cabs offers 24x7 reliable taxi service with professional drivers, clean vehicles, affordable pricing, and instant online booking.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/best-taxi-service-in-mumbai"
}
};










    return (
        <div>

<Helmet>
  <title>Best Taxi Service in Mumbai | 24x7 Cab Booking | +91 9545731161</title>

<meta
 name="description"
 content="Book the best taxi service in Mumbai for safe, affordable, and comfortable travel. 24x7 cab service for airport, local, outstation, corporate, and family trips with instant booking."
/>

<meta
 name="keywords"
 content="best taxi service in mumbai, mumbai best taxi service, top taxi service mumbai, reliable taxi service mumbai, affordable taxi service mumbai, 24x7 taxi service mumbai, mumbai airport taxi service, mumbai outstation taxi service, mumbai local taxi service, premium taxi service mumbai, mumbai corporate taxi service, mumbai family taxi service, mumbai online taxi booking, instant taxi service mumbai, safe taxi service mumbai, comfortable taxi service mumbai, mumbai city taxi service, professional taxi service mumbai, mumbai cab and taxi service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Besttaxiserviceinmumbai;